<template>
  <mds-data-table
    v-bind="$props"
    v-on="$listeners"
  >
    <template v-slot:body>
      <mds-data-table-body
        :header-configs="headerConfigs"
        :row-data="renderedRowData"
      >
        <mds-data-table-row
          v-for="(row, index) in renderedRowData"
          :id="row.id"
          :key="row.id"
          :row-index="index"
          :header-configs="headerConfigs"
          :row-data="row"
        />
      </mds-data-table-body>
    </template>
    <template v-slot:footer>
      <!--
        Slot in footer content so it can be observed.
        If the footer has been reached, we can render additional rows.
      -->
      <span v-intersect="intersectArgs" />
    </template>
  </mds-data-table>
</template>

<script>
// Transition
import { MdsDataTable, MdsDataTableBody } from '@mds/data-table'
import MdsDataTableRow from '@mds/data-table/src/data-table-body/data-table-row'
import MdsDataTableProps from '@mds/data-table/src/data-table_props'

export default {
  components: {
    MdsDataTable,
    MdsDataTableBody,
    MdsDataTableRow,
  },
  props: {
    ...MdsDataTableProps,
    /**
     * The number of additional rows to render when reaching the end of the table.
     */
    batch: {
      type: Number,
      default: 10,
      validator: value => value > 0,
    },
    /**
     * The initial number of rows to render. (revisit this approach—could potentially check how many rows would fill viewport)
     */
    bench: {
      type: Number,
      default: 50,
      validator: value => value >= 50,
    },
    /**
     * The vertical offset from root element's bounding box.
     *
     * An offset of 200 would intersect 200px before the element actually intersects with the viewport.
     * An offset of -200 would intersect 200px after the element actually intersects with the viewport.
    */
    offset: {
      type: Number,
      default: 0,
    },
  },
  data () {
    return {
      numberOfRowsToRender: this.bench,
      intersectArgs: {
        handler: this.onElementObserved,
        options: {
          root: null,
          rootMargin: `0px 0px ${this.offset}px 0px`,
          threshold: 0,
        },
      },
    }
  },
  computed: {
    allRowsRendered () {
      return this.numberOfRowsToRender >= this.rowData.length
    },
    renderedRowData () {
      return this.rowData.slice(0, this.numberOfRowsToRender)
    },
  },
  methods: {
    onElementObserved (entries) {
      if (entries[0].isIntersecting && !this.allRowsRendered) {
        this.numberOfRowsToRender = this.numberOfRowsToRender + this.batch
      }
    },
  },
}
</script>
